<template lang="pug">
    div.creator-control(:class='theClass')
        div.creator-control__avatar(@click='goToProfile' :style='avatarStyle')
            .creator-control__avatar-placeholder(v-if="!avatarSrc")
                svg-icon(iconId="profile-image-placeholder")
            slot(name='avatar-decoration')
            resize-sensor(@resize="avatarResize")
        div.creator-control__info(v-if='includeInfo')
            div.creator-control__name(:style="nameStyle")
                span(@click='goToProfile') {{ name }}
                    resize-sensor(v-if="compact" @resize="nameResize")
            template(v-if='!compact')
                div.creator-control__description(v-if='description || descriptionHtml' v-html="descriptionHtml")
                    fit-truncate-text-control(v-if='description') {{ description }}
                div.creator-control__username(v-else)
                    span(@click='goToProfile') {{ username }}
</template>

<script>


export default {
    name: 'creator-control',
    data() {
        return {
            avatarSize: {},
            nameHeight: 0,
        }
    },
    props: {
        creator: {
            type: Object,
            required: true,
        },
        includeInfo: {
            type: Boolean,
            default: true,
        },
        compact: {
            type: Boolean,
        },
        description: {
            type: String,
        },
        descriptionHtml: {
            type: String,
        },
    },
    computed: {
        avatarSrc() {
            return this.creator.profile_image
        },
        name() {
            return `${this.creator.first_name} ${this.creator.last_name}`
        },
        username() {
            return `@${this.creator.username}`
        },

        theClass() {
            return {
                'creator-control--compact': this.compact,
            }
        },

        avatarStyle() {
            const style = {}

            if (this.avatarSrc) {
                style['background-image'] = `url(${this.avatarSrc})`
            }

            const size = this.compact ? this.avatarSize.width : this.avatarSize.height
            style[this.compact ? 'height' : 'width'] = `${size + 4}px`

            return style
        },
        nameStyle() {
            if (this.compact) {
                return {
                    'height': `${this.nameHeight}px`,
                }
            }
        },
    },
    methods: {
        goToProfile() {
            if (this.creator.owner) {
                this.$router.push(`/profile`)
            }
            else {
                this.$router.push(`/user/${this.creator.username}`)
            }
            this.$emit('goToProfile')
        },

        avatarResize(e) {
            this.avatarSize = e
        },

        nameResize(e) {
            this.nameHeight = e.height
        },
    },
}
</script>
